

import { createRouter, createWebHistory } from 'vue-router'
import DetailPage from '../views/DetailPage.vue'
import PwzrDetail from '../components/PwzrDetail.vue'
import SpdtDetail from '../components/SpdtDetail.vue'
import { updateSeo, fetchSeoData } from '@/utils/seoUtils'
import DoubleNoDetail from '../components/DoubleNoDetail.vue'
import Register from '../components/RegisterPage.vue'
import config from '@/config.js'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../components/HelloWorld.vue'),
    meta: { 
      seo: null
      // seo: {
      //   title: '利康科技_权威保健食品数据库_最好用的保健食品批文查询',
      //   keywords: '免费最新最全用最好用保健食品批文查询,保健食品批文转让',
      //   description: '利康科技是专注保健食品行业,主要业务批文转让，注册，备案，延续，变更，研发新功能，换证'
      // }
    }
  },
  {
    path: '/marketing',
    name: 'marketing',
    component: () => import('../components/MarketSell.vue'),
    meta: { 
      seo: null
    }
  },

  {
    path: '/adminChat',
    name: 'adminChat',
    component: () => import('../components/AdminChatPage.vue'),
    meta: {
      seo: null
    }
  },
  {
    path: '/myLibraries',
    name: 'myLibraries',
    component: () => import('../views/MyLibraries.vue'),
    meta: {
      title: '我的批文库',
      seo: null
    }
  },

  {
    path: '/detail/:id',
    name: 'detail',
    component: DetailPage,
    meta: { 
      requiresAuth: true,
      seo: null
     } // 需要登录才能访问
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/sellApproval',
    name: 'sellApproval',
    component: () => import('../components/SellApproval.vue'),
     meta: { 
      seo: null
      // seo: {
      //   title: '利康科技_权威保健食品数据库_最好用的保健食品批文查询',
      //   keywords: '免费最新最全用最好用保健食品批文查询,保健食品批文转让',
      //   description: '利康科技是专注保健食品行业,主要业务批文转让，注册，备案，延续，变更，研发新功能，换证'
      // }
    }

  },
  {
    path: '/mailApproval',
    name: 'mailApproval',
    component: () => import('../components/MailApproval.vue'),
     meta: { 
      seo: null
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/LoginPage.vue'), // 导入登录页面
    meta: {
      title: '登录'
    }
  },

  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('../components/ResetPassword.vue'), // 导入登录页面
    meta: {
      title: '重置密码',
      requiresAuth: false // 是否需要登录，根据你的需求调整
    }
  },
  {
    path: '/pwzrList',
    name: 'PwzrList',
    component: () => import('../components/PwzrList.vue'),
     meta: null
    
  },
  {
    path: '/pwzrDetail/:id',
    name: 'PwzrDetail',
    component: PwzrDetail,
    props: true,
    meta: { 
    seo: null // 设置为null，表示需要从API获取
  }
  },
  //审评动态
  {
    path: '/spdtList',
    name: 'SpdtList',
    component: () => import('../components/SpdtList.vue'),
    meta: { 
    seo: null // 设置为null，表示需要从API获取
  }
  },
  //变更注册
  {
    path: '/changeRegistration',
    name: 'ChangeRegistration',
    component: () => import('../components/ChangeRegistration.vue'),
    meta: { 
    seo: null
  }
  },
    {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import('../components/AboutUs.vue'),
    meta: { 
    seo: null // 设置为null，表示需要从API获取
  }
  },

      {
    path: '/internationalSearch',
    name: 'internationalSearch',
    component: () => import('../components/InternationalSearch.vue'),
    meta: { 
    seo: null // 设置为null，表示需要从API获取
  }
  },
  {
    path: '/spdtDetail/:id',
    name: 'SpdtDetail',
    component: SpdtDetail,
    props: true,
    meta: { 
    seo: null // 设置为null，表示需要从API获取
  }
  },

    //双无换证
  {
    path: '/doubleNoList',
    name: 'DoubleNoList',
    component: () => import('../components/DoubleNoList.vue'),
    meta: { 
    seo: null // 设置为null，表示需要从API获取
  }
  },
  {
    path: '/doubleNoDetail/:id',
    name: 'DoubleNoDetail',
    component: DoubleNoDetail,
    props: true,
    meta: { 
    seo: null // 设置为null，表示需要从API获取
  }
  },
  //微信公众号批文推送
  {
    path: '/wxmpList',
    name: 'WxmpList',
    component: () => import('../views/WxmpListPage.vue'),
    meta: {
      title: '微信公众号批文推送',
      requiresAuth: true
    }
  },
  // 节气文章发送
  {
    path: '/solar-terms',
    name: 'SolarTerms',
    component: () => import('../components/SolarTermsArticle.vue'),
    meta: {
      title: '节气文章发送',
      requiresAuth: true
    }
  },
  // 常见流程及业务问题详情
  {
    path: '/faqDetail/:id',
    name: 'FaqDetail',
    component: () => import('../components/FaqDetail.vue'),
    props: true,
    meta: { seo: null }
  },
  // 行业热点详情
  {
    path: '/industryHotDetail/:id',
    name: 'IndustryHotDetail',
    component: () => import('../components/IndustryHotDetail.vue'),
    props: true,
    meta: { seo: null }
  },
  // 管理员菜单 - 常见流程及业务问题管理
  {
    path: '/admin/faq',
    name: 'FaqManager',
    component: () => import('../components/admin/FaqManager.vue'),
    meta: { title: '常见流程管理', requiresAuth: true, isAdmin: true }
  },
  // 管理员菜单 - 行业热点管理
  {
    path: '/admin/industry-hot',
    name: 'IndustryHotManager',
    component: () => import('../components/admin/IndustryHotManager.vue'),
    meta: { title: '行业热点管理', requiresAuth: true, isAdmin: true }
  },
  // 管理员菜单 - 批文查找规则管理
  {
    path: '/admin/search-rule',
    name: 'SearchRule',
    component: () => import('../components/admin/SearchRuleManager.vue'),
    meta: {
      title: '批文查找规则',
      requiresAuth: true,
      isAdmin: true
    }
  },
  // 管理员菜单 - 访问规则管理
  {
    path: '/admin/access-rule',
    name: 'AccessRule',
    component: () => import('../components/admin/AccessRuleManager.vue'),
    meta: {
      title: '访问规则管理',
      requiresAuth: true,
      isAdmin: true
    }
  },
  // 管理员菜单 - 黑名单管理
  {
    path: '/admin/blacklist',
    name: 'Blacklist',
    component: () => import('../components/admin/BlacklistManager.vue'),
    meta: {
      title: '黑名单管理',
      requiresAuth: true,
      isAdmin: true
    }
  },
  // 管理员菜单 - 访问日志
  {
    path: '/admin/access-log',
    name: 'AccessLog',
    component: () => import('../components/admin/AccessLogManager.vue'),
    meta: {
      title: '访问日志',
      requiresAuth: true,
      isAdmin: true
    }
  },
  // 管理员菜单 - 公众号往期文章管理
  {
    path: '/admin/gzh-sendlist',
    name: 'GzhSendlist',
    component: () => import('../components/admin/GzhSendlistManager.vue'),
    meta: {
      title: '公众号往期文章管理',
      requiresAuth: true,
      isAdmin: true
    }
  },
  // 数据看板（BI）
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: {
      title: '数据看板',
      seo: null
    }
  },
  // 管理员 - 批文转让维护（pwzr_show 可编辑明细 + 启用/禁用 + 浏览记录）
  {
    path: '/admin/pwzr-manage',
    name: 'PwzrShowManage',
    component: () => import('../views/admin/PwzrShowManage.vue'),
    meta: { title: '批文转让维护', requiresAuth: true, isAdmin: true }
  },
  // 管理员 - 客户浏览列表（按客户分组）
  {
    path: '/admin/customer-browse',
    name: 'CustomerBrowse',
    component: () => import('../views/admin/CustomerBrowseList.vue'),
    meta: { title: '客户浏览列表', requiresAuth: true, isAdmin: true }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router

// 全局前置守卫：处理小程序传入的wx_token和wx_userInfo
router.beforeEach((to, from, next) => {
  const isWxMini = /miniProgram/i.test(navigator.userAgent)
  if (isWxMini) {
    const wxToken = to.query.wx_token
    const wxUserInfo = to.query.wx_userInfo
    if (wxToken) {
      localStorage.setItem('token', wxToken)
      // 如果有userInfo，也存入localStorage
      if (wxUserInfo) {
        try {
          const userInfoObj = JSON.parse(decodeURIComponent(wxUserInfo))
          localStorage.setItem('userInfo', JSON.stringify(userInfoObj))
          // 小程序登录自动使用微信头像/昵称：同步到后端用户资料
          syncWxProfile(wxToken, userInfoObj)
        } catch (e) {
          console.error('解析wx_userInfo失败:', e)
        }
      }
      // 移除URL中的参数，避免重复处理
      const query = { ...to.query }
      delete query.wx_token
      delete query.wx_userInfo
      delete query.t
      next({ path: to.path, query, replace: true })
      return
    }
  }
  next()
})

// 微信头像/昵称同步到后端（fire-and-forget，失败不影响登录）
const syncWxProfile = (token, userInfoObj) => {
  try {
    const payload = {}
    if (userInfoObj.avatarUrl) payload.avatar = userInfoObj.avatarUrl
    if (userInfoObj.nickName) payload.nickname = userInfoObj.nickName
    if (userInfoObj.gender !== undefined && userInfoObj.gender !== null) {
      payload.gender = String(userInfoObj.gender) === '2' ? 'female' : 'male'
    }
    if (Object.keys(payload).length === 0) return
    const cleanToken = token.startsWith('Bearer ') ? token : `Bearer ${token}`
    fetch(`${config.API_BASE_URL}/api/user/profile`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: cleanToken },
      body: JSON.stringify(payload)
    }).catch(() => { /* ignore */ })
  } catch (e) {
    console.error('微信资料同步失败:', e)
  }
}

// 添加路由导航守卫
router.afterEach(async (to) => {
  // 如果路由有预定义的SEO配置，直接使用
  if (to.meta.seo) {
    updateSeo(to.meta.seo);
  } else {
    // 否则从API获取
    const seoData = await fetchSeoData(to);
    updateSeo(seoData);
  }
});